var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('center',[_c('div',{staticClass:"display-3 mt-5"},[_vm._v("404. Page not found.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }